module.exports = "---\ntitle: \"AI生成\"\ntime: \"2024-10-22\"\n---\n\nAI生成标注正式上线！与普通文章不同，由AI生成的文章会在存档页面显示为浅绿色用于区分。\n";